<template>
  <div>
    <div class="display_table min_width_100_percent">
      <div class="is-flex title_container is-align-items-center">
        <a
          @click="$emit('create')"
          v-if="is_createable"
          class="unique_button button is-info is-outlined"
          >Create new resource</a
        >
        <div v-for="unique_button in unique_buttons" :key="unique_button.name">
          <button
            v-if="!unique_button.component"
            @click="$emit(unique_button.name)" class="unique_button button"
            :class="getCssClasses({}, unique_button)">
            {{unique_button.display_text}}
          </button>
          <component
            v-else
            :is="unique_button.component"
            v-bind="unique_button"
          >
          </component>
        </div>
      </div>
      <div class="is-flex title_container is-flex-wrap-wrap">
        <div class="is-align-self-flex-end">
          <page-title :title="title" :additionData="getLonePositionAdditionData" :pageTitleAdditions="pageTitleAdditionData"></page-title>
          <div class="relative" v-if="response.length == 0  || is_th_searching">
            <div class="loading center_horizontal" v-if="is_loading || is_th_searching"></div>
            <p v-else>No Results.</p>
          </div>
        </div>
        <div class="horizontal_space"></div>
        <div class="is-flex">
          <sorters :sorters="sorters"></sorters>
          <single-filters :filters="getFiltersByType('single')"></single-filters>
          <date-filters :filters="getFiltersByType('date')"></date-filters>
          <div v-if="show_load_ghana_flags_button" class="is-align-self-flex-end">
            <div class="is-flex is-align-items-center">
              <div class="horizontal_space"></div>
              <a @click="loadAllGhanaFlags()" class="button is-info">#</a>
              <div class="horizontal_space"></div>
              <a v-if="show_sort_ghana_flags_button" @click="prepareSortByGhanaFlags()" class="button is-danger" :class="{ 'is-loading': is_sorting_ghana_flags }"># ➞</a>
            </div>
          </div>
        </div>
        <div>
          <range-filters :filters="getFiltersByType('range')"></range-filters>
        </div>
      </div>
      <div class="is-flex">
        <FilterInput :filters="getFiltersByType('input')"></FilterInput>
        <FilterCheckbox :filters="getFiltersByType('checkbox')"></FilterCheckbox>
      </div>
      <div>
        <FilterMultiTermInput :filters="getFiltersByType('multi_term_input')"></FilterMultiTermInput>
      </div>
      <div class="columns">
        <div class="column">
          <ModalFilters :filters="getFiltersByType('modal')"/>
        </div>
        <div class="column">
          <div v-for="counter in counters" :key="counter.name" class="is-flex">
            <DisplayCounter :label="counter.label" :value="counter.value" />
          </div>
        </div>
      </div>
      <multiple-filters :filters="getFiltersByType('multiple')" class="title_container filters"></multiple-filters>
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table id="table" class="table center-aligned-table">
              <thead-searches v-if="show_header_filter" @th_search="thSearch({ searches: $event, is_plain_search: false })" :is_plain_search="false" :fields="getFields"
                              :working_th_searches="working_th_searches">
              </thead-searches>
              <thead-searches v-if="show_header_filter" @th_search="thSearch({ searches: $event, is_plain_search: true })" :fields="getFields" :working_th_searches="working_th_searches">
              </thead-searches>
              <thead>
                <tr>
                  <th
                    :key="field.name"
                    v-for="field in fields"
                    class="tr_field_name border-bottom-0"
                  >
                    {{ field.name }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="!is_sorting_ghana_flags">
                <tr
                  :class="{ odd: index % 2 == 0 }"
                  :key="index"
                  v-for="(row_data, index) in mutable_response"
                >
                  <td class="fade_animation" :key="`${index}/${field.name}`" v-for="field in getFields" :class="getCssClasses(row_data, field)">
                    <operations v-if="field.type == 'operations'" :show_edit="show_edit" :show_delete="show_delete" :operations="operations" :payload="row_data"
                                @operation_clicked="$emit($event.event_name, $event.event_data)">
                    </operations>
                    <div v-else>
                      <component
                        v-if="typeof field.component == 'string'"
                        :is="field.component"
                        :ref="field.component"
                        :payload="getComponentData(row_data, field.component_data_path)"
                        :additional_data="field.additional_data"
                        v-bind="field.props"
                      ></component>
                      <div v-else>
                        <p>{{ getFieldData(row_data, field) }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style="padding: 20px; padding-top: 0;">
              {{ response.length + " Entries" }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPropertyFromPathSafely } from '@/custom/classes/my_utils.js'
import TimeHelper from '@/custom/classes/time_helper.js'
import PageTitle from '@/components/PageTitle'
import Operations from '@/components/Operations'
import GhanaFlag from '@/components/GhanaFlag'
import StartVetting from '@/components/applicants/StartVetting'
import LinkEntity from '@/components/LinkEntity'
import AlertLinkEntity from '@/components/AlertLinkEntity'
import Sorters from '@/components/Sorters'
import SingleFilters from '@/components/FilterSingle'
import FilterInput from '@/components/FilterInput'
import FilterCheckbox from '@/components/FilterCheckbox'
import FilterMultiTermInput from '@/components/FilterMultiTermInput'
import MultipleFilters from '@/components/FilterMultiples'
import RangeFilters from '@/components/FilterRange'
import DisplayCounter from '@/components/DisplayCounter'
import DateFilters from '@/components/FilterDate'
import ModalFilters from '@/components/FilterModal'
import TheadSearches from '@/components/TheadSearches'
import OfferStatus from '@/components/OfferStatus'
import TextSearchResultContainer from '@/components/TextSearchResultContainer'
import Message from '@/components/Message'
import DisplaySkills from '@/components/DisplaySkills'
import Tags from '@/components/Tags'
import DataTableMethodTwo from '@/components/DataTableMethodTwo'
import TableCellFormattedText from '@/components/TableCellFormattedText'
import TableCellDuration from '@/components/TableCellDuration'
import TableCellLiteResources from '@/components/TableCellLiteResources'
import TableCellOwner from '@/components/TableCellOwner'
import TableCellOwnerWithCheck from '@/components/TableCellOwnerWithCheck'
import TableCellTiming from '@/components/TableCellTiming'
import TableCellPositionTitle from '@/components/TableCellPositionTitle'
import TableCellEditableInput from '@/components/shared/molecules/TableCellEditableInput'
import PositionStatus from '@/components/PositionStatus'
import TableCellFullName from '@/components/TableCellFullName'
import TableCellCopyId from '@/components/TableCellCopyId'
import TableCellApplicantSkill from '@/components/TableCellApplicantSkill'
import AlertContent from '@/components/AlertContent'
import AlertResourceCell from '@/components/AlertResourceCell'
import OutsourcePositionLinkEntity from '@/components/OutsourcePositionLinkEntity'
import OutsourceCompanyLinkEntity from '@/components/OutsourceCompanyLinkEntity'
import OfferDistance from '@/components/OfferDistance'
import PresenceReportLogoutContent from '@/components/PresenceReportLogoutContent'
import PresenceReportTotalHours from '@/components/PresenceReportTotalHours'
import PresenceReportNotesContent from '@/components/PresenceReportNotesContent'
import ButtonEvaluate from '@/components/ButtonEvaluate'
import ScoreThisPage from '@/components/positions/offers/ScoreThisPage'
import SentCodesDisplay from '@/components/SentCodesDisplay'
import PhoneCallButton from '@/components/PhoneCallButton'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    pageTitleAdditionData: {
      type: Object,
      default: () => ({})
    },
    show_edit: {
      type: Boolean,
      default: true
    },
    show_delete: {
      type: Boolean,
      default: true
    },
    show_operations: {
      type: Boolean,
      default: true
    },
    show_header_filter: {
      type: Boolean,
      default: true
    },
    sorters: {
      type: Array,
      default: () => []
    },
    counters: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    response: {
      type: Array,
      default: () => ([])
    },
    operations: {
      type: Array,
      default: () => []
    },
    unique_buttons: {
      type: Array,
      default: () => []
    },
    is_createable: {
      type: Boolean,
      default: true
    },
    show_load_ghana_flags_button: {
      type: Boolean,
      default: false
    },
    show_sort_ghana_flags_button: {
      type: Boolean,
      default: true
    },
    working_th_searches: {
      type: Array,
      default: () => undefined
    }
  },
  name: 'datatable',
  data () {
    return {
      time_helper: new TimeHelper(),
      th_searches: [],
      is_plain_search: true,
      is_loading: true,
      is_th_searching: false,
      th_search_timeout: {},
      is_sorting_ghana_flags: false,
      mutable_response: [...this.response]
    }
  },
  computed: {
    is_reverse_search () {
      return !this.is_plain_search
    },
    getFields () {
      let fields = this.fields
      if (this.show_operations) {
        fields.unshift({ name: 'operations', type: 'operations' })
      }
      return fields
    },
    getLonePositionAdditionData () {
      if (this.response.length == 1) {
        return {
          priority_warning: this.response[0].priority_warning
        }
      }
      return undefined
    }
  },
  watch: {
    response (response) {
      this.mutable_response = [...response]
      if (response.length == 0) {
        this.is_loading = false
      }
      this.is_th_searching = false
      if (response.length > 0 && this.$route.query.is_sort_ghana_flags) {
        this.$nextTick(() => {
          this.loadAllGhanaFlags({ sort: true })
        })
      }
    }
  },
  methods: {
    getFiltersByType (type) {
      return this.filters.filter(filter => filter.type == type)
    },
    loadAllGhanaFlags (params) {
      let ghana_flags_components = this.$refs.GhanaFlag
      let requests = []
      for (let i = 0; i < ghana_flags_components.length; i++) {
        requests.push(this.$refs.GhanaFlag[i].showCountOnly())
      }
      if (params != undefined && params.sort == true) {
        this.is_sorting_ghana_flags = true
        Promise.all(requests).then(response => {
          this.sortTableByGhanaFlag(response)
        })
      }
    },
    prepareSortByGhanaFlags () {
      let query = { ...this.$route.query }
      query.is_sort_ghana_flags = true
      this.$router.push({ name: this.$route.name, query })
    },
    sortTableByGhanaFlag (rows_colors) {
      this.mutable_response.map((row, index) => {
        row.ghana_flag_counts = rows_colors[index]
        return row
      })
      this.mutable_response.sort((a, b) => {
        return b.ghana_flag_counts.purple - a.ghana_flag_counts.purple
      })
      this.is_sorting_ghana_flags = false
      this.$nextTick(() => {
        this.mutable_response.forEach((row, index) => {
          let counts = row.ghana_flag_counts
          this.$refs.GhanaFlag[index].purple_count_only = counts.purple
          this.$refs.GhanaFlag[index].green_count_only = counts.green
          this.$refs.GhanaFlag[index].orange_count_only = counts.orange
          this.$refs.GhanaFlag[index].red_count_only = counts.red
          this.$refs.GhanaFlag[index].dark_red_count_only = counts.dark_red
        })
      })
    },
    getCssClasses (row_data, field) {
      if (field.css_classes == undefined) {
        return {}
      }
      let classes = {}
      for (let key in field.css_classes) {
        let method = field.css_classes[key]
        classes[key] = method(row_data)
      }
      return classes
    },
    thSearch (params) {
      this.is_plain_search = params.is_plain_search
      this.th_searches = params.searches
      this.is_th_searching = true
      clearTimeout(this.th_search_timeout)
      this.th_search_timeout = setTimeout(this.filterThs, 500)
    },
    filterThs () {
      let th_filters = {}
      for (let i = 0; i < this.th_searches.length; i++) {
        let th_filter = this.th_searches[i]
        if (th_filter.term.length == 0) {
          continue
        }
        th_filters[th_filter.name] = th_filter.term
      }

      this.$emit('thFilter', th_filters)
    },
    getComponentData (row_data, component_data_path) {
      if (component_data_path == undefined) {
        return row_data
      }
      return getPropertyFromPathSafely({ context: row_data, path: component_data_path })
    },
    getFieldData (row_data, field) {
      let field_data = getPropertyFromPathSafely({ context: row_data, path: field.value })
      if (field_data == undefined) {
        return ''
      }
      if (field.is_time) {
        return this.time_helper.makeTimeReadable(field_data)
      }
      return field_data
    }
  },
  components: {
    PageTitle,
    Operations,
    GhanaFlag,
    StartVetting,
    LinkEntity,
    AlertLinkEntity,
    Sorters,
    TableCellFullName,
    TableCellCopyId,
    SingleFilters,
    FilterInput,
    FilterCheckbox,
    FilterMultiTermInput,
    MultipleFilters,
    RangeFilters,
    TableCellDuration,
    TableCellLiteResources,
    TableCellFormattedText,
    TableCellPositionTitle,
    TableCellApplicantSkill,
    ScoreThisPage,
    AlertResourceCell,
    DateFilters,
    ModalFilters,
    TableCellEditableInput,
    TheadSearches,
    DisplayCounter,
    OfferStatus,
    TableCellOwner,
    TableCellOwnerWithCheck,
    DataTableMethodTwo,
    Message,
    DisplaySkills,
    Tags,
    TableCellTiming,
    ButtonEvaluate,
    PositionStatus,
    AlertContent,
    OutsourcePositionLinkEntity,
    OutsourceCompanyLinkEntity,
    OfferDistance,
    PresenceReportLogoutContent,
    PresenceReportTotalHours,
    PresenceReportNotesContent,
    TextSearchResultContainer,
    SentCodesDisplay,
    PhoneCallButton
  }
}
</script>
<style scoped>
table {
  border-collapse: separate;
}
.tr_field_name {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2) !important;
}
.mandatory_question p{
  display: inline-block;
  font-weight: bold;
  border-radius: 30px;
  padding: 10px 30px;
  background-color: orange;
}
.card{
  margin-top: 20px;
}
.unique_button{
  margin-right: 10px;
}
.loading {
  margin-bottom: 10px;
}
.filters {
  margin-top: 10px;
  width: 84vw;
}
.title_container {
  max-width: 84vw;
  margin-top: 10px;
  margin-left: 30px;
}
td {
  max-width: 300px;
  word-wrap: break-word;
}
.max-width-450 {
  max-width: 450px;
}
.fade_animation {
    -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 1s; /* Firefox < 16 */
        -ms-animation: fadein 1s; /* Internet Explorer */
         -o-animation: fadein 1s; /* Opera < 12.1 */
            animation: fadein 1s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

</style>
